import React, { useRef, useEffect, useState } from "react";

import useHttp from "../../../hooks/use-http";

import moment from "moment";
import convertToExcel from "../../../components/ExportToExcel";
import Pagination from "../../../components/Pagination";

const VanStock = () => {
  const [data, setData] = useState([]);
  const { sendRequest: getMarketSurvey } = useHttp();

  const getData = () => {
    getMarketSurvey(
      {
        url: `/api/userIssuedStock/?orgId=${localStorage.getItem("orgId")}&empId=${localStorage.getItem("empId")}`,
      },
      (res) => {
        if (res) {
          const sortedData =
            res &&
            res.sort((a, b) => b.userIssuedStockId - a.userIssuedStockId);

          setData(sortedData);

          //console.log(res);
        }
      }
    );
  };

  useEffect(() => {
    getData();
  }, []);

  const [employeeData, setEmployeeData] = useState([]);

  const { sendRequest: getEmp } = useHttp();

  useEffect(() => {
    getEmp(
      {
        url: `/api/employeeByUsecase/?orgId=${localStorage.getItem(
          "orgId"
        )}&useCase=Sales`,
      },
      (data) => {
        setEmployeeData(data.output);
      }
    );
  }, [getEmp]);

  const handleEmpChange = (e) => {
    const id = e.target.value;
    if (id) {
      getMarketSurvey(
        {
          url: `/api/userIssuedStock/?orgId=${localStorage.getItem(
            "orgId"
          )}&employeeId=${id}`,
        },
        (res) => {
          if (res) {
            const sortedData =
              res &&
              res.sort((a, b) => b.userIssuedStockId - a.userIssuedStockId);

            setData(sortedData);

            //console.log(res);
          }
        }
      );
    } else {
      getData();
    }
  };

  const fieldsToExport = [
    "requestDocNo",
    "createdDate",
    "employeeName",
    "productName",
    "productQuantity",
    "unitName",
  ];

  const customHeaders = [
    "Request No",
    "Date Of Issued",
    "Executive Name",
    "Product Name",
    "Quantity",
    "Unit",
  ];

  const handleExportExcel = () => {
    const filename = "VanSalesReport.xlsx";
    convertToExcel(data, fieldsToExport, filename, customHeaders);
  };
  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="row mx-2">
              {" "}
              <h3 className="card-title mx-3 my-1">Van Stock</h3>
            </div>

            <div className="row">
              <div className="col-md-3 mx-3 my-2">
                <label htmlFor={"executive_officer"}>{"Field Executive"}</label>
                <select
                  id="emp_id"
                  className="form-control"
                  onChange={handleEmpChange}
                >
                  <option value="">Select</option>
                  {employeeData &&
                    employeeData.map((x) => (
                      <option key={x.empId} value={x.empId}>
                        {x.employeeName}
                      </option>
                    ))}
                </select>
              </div>

              <div className="col-md-3 mx-3 my-4">
                <button className="btn btn-sm btn-primary">Submit</button>
              </div>
            </div>
          </div>

          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered  text-center table-sm">
                      <thead>
                        <tr className="table-header">
                          <th>Request No</th>
                          <th>Date Of Issued</th>
                          <th>Executive Name</th>

                          <th>Product Name</th>
                          <th>Quantity</th>
                          <th>Unit</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((x, i) => {
                            return (
                              <tr key={x.userIssuedStockId}>
                                <td>{x.requestDocNo}</td>
                                <td>{x.createdDate}</td>
                                <td>{x.employeeName}</td>
                                <td>{x.productName}</td>

                                <td>{x.productQuantity}</td>
                                <td>{x.unitName}</td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default VanStock;
